import styled from "styled-components";

const ChangeMarkerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-start;
  flex-grow: 1;
  height: 48px;
  padding-right: 10px;
`;

export default ChangeMarkerContainer;
